// a read-only collection of data passed from the server
'use strict';

var embed = require('./embedded-data') || {};
var clientData = embed.data || {};
var extend = require('underscore').extend;
var rDotProperty = /\./;


function accessDotProperty(object, dotSyntaxProperty) {
  var properties = (dotSyntaxProperty || '').split('.');
  var value;
  properties.every(function(property) {
    value = object[property];
    if (value === undefined) {
      return false;
    } else {
      object = value;
    }
    return true;
  });

  return value;
}

function getProperty(key, isNullable) {
  clientData = clientData || {};
  if (key === undefined) {
    // allows returning the entire embedded object, for debugging purposes
    return extend({}, clientData);
  }

  var value = rDotProperty.test(key) ? accessDotProperty(clientData, key) : clientData[key];
  if (typeof value === 'undefined' || value === null) {
    // coerce undefined to null - Json.NET will not send null values
    if (isNullable) {
      return null;
    } else {
      // likely a typo
      throw new Error(('Request for non-nullable data property "' + key + '" failed. ' +
        'Property not found. Check the property\'s spelling and ensure it is camel-cased. ' +
        'If the property can contain a null value, use require("data").nullable("' + key + '") instead.').replace(/"/g, '\''));
    }
  }
  // create a new object instead of returning a pointer
  return JSON.parse(JSON.stringify(value));
}

// build up our export object
var API = {
  raw: function() {
    return JSON.parse(JSON.stringify(embed));
  },
  get: function(key) {
    return getProperty(key, false);
  },
  getNullable: function(key) {
    ///<summary>This allows retrieving properties that may not have been defined.
    /// Use this method with caution, as incorrect property names will yield a null result instead of an error.</summary>
    return getProperty(key, true);
  },
};

// Extend our API object (the export) so that older usages will throw an exception if they
// are invoked.
if (Object.defineProperties) {
  // can uncomment this if we don't want to run this on prod (keep prod and thor the same)  // && !/(thor)?hudl.com$/.test(location.hostname)) {
  // add transition warnings for invalid data module usage
  for (var prop in clientData) {
    if (!clientData.hasOwnProperty(prop)) {
      continue;
    }
    var val = clientData[prop];
    // want to catch old Pascal-cased properties too
    var pascalCased = prop.charAt(0).toUpperCase() + prop.substring(1);
    [prop, pascalCased].forEach(function (p) {
      // don't overwrite any actual properties
      if (!API.hasOwnProperty(p)) {
        Object.defineProperty(API, p, {
          get: function () {
            throw new Error(('Invalid access for property "' + p + '". ' +
              'The data module should be used as a function: ' +
              'require("data")("' + prop + '") instead of require("data").' + p + '.').replace(/"/g, '\''));
          },
          enumerable: false,
          configurable: false,
        });
      }
    });
  }
}

module.exports = API;
